import {Pipe, PipeTransform} from '@angular/core';
import {formatBytes} from '@brunata-angular/util';

@Pipe({
    name: 'appformatbytes',
    standalone: true,
})
export class FormatBytesPipe implements PipeTransform {
    transform(value: number | null | undefined, decimals?: number): string {
        if (value == null) {
            return '';
        }
        return formatBytes(value, decimals ?? 1);
    }
}
